import React from "react";
import { motion } from "framer-motion";

const adminFlow = ["Invite contractor", "Review profile", "Approve", "Assign project", "Process payout"];
const contractorFlow = ["Receive invite", "Complete onboarding", "Upload documents", "Sign contracts", "Track work", "Get paid"];

const Lane = ({ title, steps, accent, testId }) => (
  <div data-testid={testId}>
    <div className="text-[10px] uppercase tracking-[0.22em] mb-5" style={{ color: accent }}>
      {title}
    </div>
    <div className="relative">
      <div className="absolute left-3 top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[#152222] to-transparent" />
      <ol className="space-y-4">
        {steps.map((s, i) => (
          <motion.li
            key={s}
            initial={{ opacity: 0, x: -8 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="relative flex items-center gap-4 pl-9"
          >
            <span
              className="absolute left-0 w-6 h-6 rounded-full grid place-items-center border"
              style={{ background: `${accent}18`, borderColor: `${accent}55` }}
            >
              <span className="w-1.5 h-1.5 rounded-full" style={{ background: accent }} />
            </span>
            <span className="text-sm text-white">{s}</span>
            <span className="ml-auto text-[10px] font-mono text-[#7A9B9B]">step.0{i + 1}</span>
          </motion.li>
        ))}
      </ol>
    </div>
  </div>
);

export default function Timeline() {
  return (
    <section data-testid="timeline-section" className="relative py-16 sm:py-24 lg:py-36 border-t border-[#0E1A1A]">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="text-[11px] uppercase tracking-[0.22em] text-[#FF4F00] font-bold mb-3"
        >
          Flows
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.65, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] leading-[1.02] font-medium max-w-3xl mb-8 sm:mb-14"
        >
          From invitation to <span className="italic font-normal text-[#9BB8B8]">payout</span>.
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 relative">
          <Lane title="Admin flow" steps={adminFlow} accent="#FF4F00" testId="admin-flow" />
          <Lane title="Contractor flow" steps={contractorFlow} accent="#34D399" testId="contractor-flow" />

          {/* Decorative connection between lanes */}
          <svg
            className="hidden md:block absolute left-1/2 top-12 -translate-x-1/2 pointer-events-none"
            width="40"
            height="320"
            viewBox="0 0 40 320"
            aria-hidden
          >
            <line
              x1="20"
              y1="0"
              x2="20"
              y2="320"
              stroke="#152222"
              strokeDasharray="4 6"
              className="animated-dash"
            />
          </svg>
        </div>
      </div>
    </section>
  );
}
